import styled from 'styled-components';

export const Container = styled.div`
  background: #f9f9fb 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const ForgetPasswordBox = styled.div`
  border: 1px solid #dfdfe6;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 8px;
  opacity: 1;
  padding: 20px;
  margin-bottom: 50px;
`;

export const ImageContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin: 20px 0 20px 0;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: normal;
  text-align: center;
  margin-bottom: 10px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  flex: 1;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  height: 90px;
`;

export const Think = styled.label`
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #2e384d;
  text-transform: uppercase;
  opacity: 1;
  margin-bottom: 8px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-around;
  flex: 1;
`;

export const Input = styled.input`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #dfe3e8;
  border-radius: 4px;
  opacity: 1;
  width: 335px;
  height: 45px;
  font-size: 14px;
  letter-spacing: 0px;
  color: #6b7786;
  opacity: 1;
  padding-left: 16px;
`;

export const InputError = styled.p`
  font-size: 11px;
  color: red;
  text-align: left;
`;

export const Button = styled.button`
  width: 335px;
  height: 40px;
  background: #2699fb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  border: none;
  color: #fff;
  font-size: 12px;
  opacity: 1;
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 30px;
`;

export const MustContain = styled.div`
  text-align: left;
`;

export const ContainTitle = styled.p`
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2699fb;
  opacity: 1;
`;

export const UpperSubtitle = styled.p`
  font-size: 12px;
  color: red;

  ${(props) =>
    props.upperTest
      ? 'text-decoration:line-through;color: green;'
      : 'text-decoration: none;'};
`;

export const NumberSubtitle = styled.p`
  font-size: 12px;
  color: red;

  ${(props) =>
    props.numberTest
      ? 'text-decoration:line-through;color: green;'
      : 'text-decoration: none;'};
`;

export const MinSubtitle = styled.p`
  font-size: 12px;
  color: red;

  ${(props) =>
    props.minTest
      ? 'text-decoration:line-through;color: green;'
      : 'text-decoration: none;'};
`;

export const CharSubtitle = styled.p`
  font-size: 12px;
  color: red;

  ${(props) =>
    props.charTest
      ? 'text-decoration:line-through;color: green;'
      : 'text-decoration: none;'};
`;
